import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { clearAdminSession } from "@utils/adminAuth";
// import storeConfig from "@Redux/store";
// import { getSession } from "@Pages/Auth/lib";

// const { store } = storeConfig();

export class Api {
  private api: AxiosInstance;

  public constructor(config: AxiosRequestConfig) {
    this.api = axios.create(config);

    // this middleware is been called right before the http request is made.
    this.api.interceptors.request.use((param: AxiosRequestConfig) => {
      // const token = store
      //   ?.getState()
      //   ?.loginReducer?.get("payload")
      //   ?.get("result")
      //   ?.get("token") || getSession('qc_sid') ;
      // const token = getSession('sid');

      let headersConfig: any = {};
      // if (token) {
      //   headersConfig = {
      //     ...headersConfig,
      //     Authorization: `Bearer ${token}`,
      //     "x-role-context": "admin"
      //   };
      // }

      return {
        ...param,
        headers: { ...param?.headers, ...headersConfig },
      };
    });

    // this middleware is been called right before the response is get it by the method that triggers the request
    this.api.interceptors.response.use((param: AxiosResponse) => {
      const { status } = param;
      if (status === 498) {
        clearAdminSession();
        window.location.replace("/login");
      }
      return param;
    },
    (error: any) => {
      if (error.response?.status === 498) {
        clearAdminSession();
        window.location.replace("/login");
      }
      throw error;
    });
  }

  public getUri(config?: AxiosRequestConfig): string {
    return this.api.getUri(config);
  }

  public request<T, R = AxiosResponse<T>>(
    config: AxiosRequestConfig
  ): Promise<R> {
    return this.api.request(config);
  }

  public get<T, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.api.get(url, config);
  }

  public delete<T, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.api.delete(url, config);
  }

  public head<T, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.api.head(url, config);
  }

  public post<T, R = AxiosResponse<T>>(
    url: string,
    data?: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.api.post(url, data, config);
  }

  public put<T, R = AxiosResponse<T>>(
    url: string,
    data?: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.api.put(url, data, config);
  }

  public patch<T, R = AxiosResponse<T>>(
    url: string,
    data?: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.api.patch(url, data, config);
  }
}
